import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Overlay } from "react-bootstrap";
import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';

import IconButton from "shared/react_components/IconButton";

const EmojiPicker = ({ onEmojiSelect }) => {
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(false);
  const icon = useRef();

  const toggle = () => setEmojiPickerOpen(!emojiPickerOpen);

  // We're using an Overlay react-bootstrap component so that clicks outside of the emoji clicker auto-close it.
  return (
    <React.Fragment>
      <div ref={icon}>
        <IconButton icon="insert_emoticon" onClick={toggle}/>
      </div>
      <Overlay show={emojiPickerOpen} target={icon} placement="left" rootClose onHide={toggle}>
        <Picker style={{ zIndex: 999, display: emojiPickerOpen ? "block" : "none" }}
          title="" emoji="" onSelect={emoji => onEmojiSelect(emoji.native)}
        />
      </Overlay>
    </React.Fragment>
  );
};

EmojiPicker.propTypes = {
  onEmojiSelect: PropTypes.func.isRequired
};

export default EmojiPicker;
